import axios from './_nestAxios'

export const importarRegistros = (tipoRegistro, data) =>
  axios.post('/kardex-temporal/importar/registros-x-plantilla', data, {
    params: {
      tipoRegistro: tipoRegistro
    }
  })

export const procesarRegistros = data => axios.post('/kardex-temporal/procesar-registros', data)

export const getTempInventario = _id => axios.get(`/kardex-temporal/${_id}`)

export const getPlantillaMarcas = data =>
  axios.post('/kardex-temporal/descargar/plantilla-marcas', data, { responseType: 'blob' })
export const getPlantillaUbicaciones = data =>
  axios.post('/kardex-temporal/descargar/plantilla-ubicaciones', data, { responseType: 'blob' })
export const getPlantillaCategorias = data =>
  axios.post('/kardex-temporal/descargar/plantilla-categorias', data, { responseType: 'blob' })

export const getReporte = idUsuario =>
  axios.get('/kardex-temporal/descargar/reporte-actuales', {
    responseType: 'blob',
    params: { idUsuario: idUsuario }
  })

export const nuevoTempInventario = data => axios.post('/kardex-temporal', data)
export const actualizarTempInventario = (_id, data) => axios.put(`/kardex-temporal/${_id}`, data)
export const eliminarTempInventario = _id => axios.delete(`/kardex-temporal/${_id}`)
